<template>
  <div :class="dynamicClasses" class="row">
   <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nna-row',
  props: {
    separator: {
      type: Boolean, 
      default: false,
    },   
  },
  computed: {
    dynamicClasses () {
      return {
        ['row--separator'] : this.separator
      }
    }
  }
}
</script>
<style scoped>
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.row--separator {
  border-bottom: 1px solid #ddd;
}
</style>




// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/Row/Row.vue